export default __webpack_public_path__ + "media/src/assets/images/truck-1-9dd9471088f9b5548cae07b8d22ea5c4.png";